import { render, staticRenderFns } from "./ProjectActionLayers.vue?vue&type=template&id=54a089de"
import script from "./ProjectActionLayers.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectActionLayers.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports